import { useQuery } from "@tanstack/react-query"

import { NOTIFICATION_QUERY_KEY,
        NOTIFICATION_NOT_READ_QUERY_KEY,
        NOTIFICATION_NOT_READ_COUNT_QUERY_KEY,
        NOTIFICATION_COUNT_BY_VERIFICATION_AWAITS_QUERY_KEY } from "@/constants/query"
import { 
    getNotificationsByCurrentUser,
    getNotReadNotificationsByCurrentUser,
    getNotReadCountNotificationsByCurrentUser, 
    getCountByAwaitsVerificationStatus
} from "@/http/notification"

import { IRequestParams } from "@/types/api"


export const useNotification = (params?: IRequestParams, customerId?: number) => {
    return useQuery({
        queryFn: () => getNotificationsByCurrentUser(params ?? {}, customerId),
        queryKey: [NOTIFICATION_QUERY_KEY, params, customerId],
        retry: false
    })
}

export const useNotReadNotification = (countRecord?: number) => {
    return useQuery({
        queryFn: () => getNotReadNotificationsByCurrentUser(countRecord),
        queryKey: [NOTIFICATION_NOT_READ_QUERY_KEY],
        retry: false
    })
}

export const useNotReadCountNotification = () => {
    return useQuery({
        queryFn: () => getNotReadCountNotificationsByCurrentUser(),
        queryKey: [NOTIFICATION_NOT_READ_COUNT_QUERY_KEY],
        retry: false
    })
}

export const useCountByVerificationAwaitsQuery = (enable: boolean, customerId?: number) => {
    return useQuery({
        queryFn: () => getCountByAwaitsVerificationStatus(customerId),
        queryKey: [NOTIFICATION_COUNT_BY_VERIFICATION_AWAITS_QUERY_KEY],
        retry: false,
        enabled: enable
    })
}